export default function getStyles(props = {}, styles = {}) {
  const { yotpo } = props;

  return {
    description: {
      desktop: {
        'marginTop': 'medium',
        '@xs-only': {
          display: 'none'
        }
      },
      mobile: {
        'display': 'none',
        '@xs-only': {
          display: 'block'
        }
      }
    },
    noProduct: {
      fontSize: 'large',
      textAlign: 'center'
    },
    wrapper: {
      position: 'relative',
      paddingTop: 'medium'
    },
    assetsWrapper: {
      'marginBottom': 'medium',
      '@xs-only': {
        textAlign: 'center'
      }
    },
    name: {
      'marginBottom': `${typeof yotpo !== 'undefined' ? 'xsmall' : 'small'}`,
      'textAlign': 'center',
      '@sm': {
        textAlign: 'left'
      }
    },
    similarProducts: {
      paddingTop: 'xxlarge',
      paddingBottom: 'large'
    },
    smartRibbon: {
      label: {
        'marginBottom': 'small',
        '@xs-only': {
          textAlign: 'center'
        }
      }
    },
    ...styles
  };
}
